import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CountriesList from './components/Countries/CountriesList';
import SelfieEditor from './selfie-editor/SelfieEditor';
import PrintLayout from './selfie-editor/components/PrintLayout';
import PassportCountries from './selfie-editor/components/PassportCountries';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/countries" element={<CountriesList />} />
          
          {/* Photo Editor Features */}
          <Route path="/features" element={<SelfieEditor />} />
          <Route path="/photo-editor" element={<SelfieEditor />} />
          <Route path="/print-layout" element={<PrintLayout />} />
          <Route path="/passport-sizes" element={<PassportCountries />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
